
export function normalizeSchemaName(name: string | null) {
  return `${name}`.startsWith('s:') ? `${name}` : `s:${name}`;
}
